const isProduction = process.env.NODE_ENV === 'production';
const api = {
  rest: isProduction ? '<%CMS_APP_REST_URL%>' : 'http://localhost:1337',
  graphql: isProduction ? '<%CMS_APP_GRAPHQL_URL%>' : 'http://localhost:1337/graphql',
};

export {
  api,
};
